var _excluded = ["children"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";
import PropTypes from "prop-types";

var Link = function Link(_ref) {
  var children = _ref.children,
      rest = _objectWithoutProperties(_ref, _excluded);

  // if a target prop such as target="_blank" is passed in you need to add
  // rel="noopener" for security: https://developers.google.com/web/tools/lighthouse/audits/noopener
  var rel_prop = rest.target ? {
    rel: "noopener"
  } : {};
  return /*#__PURE__*/React.createElement("a", _extends({
    "aria-label": rest["aria-label"] || rest.title
  }, rel_prop, rest), children);
};

Link.propTypes = {
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.string, PropTypes.number, PropTypes.array]),
  title: PropTypes.string.isRequired
};
Link.defaultProps = {
  children: function children() {
    return null;
  }
};
export default Link;